import { SvgIcon } from "@mui/material";

function Linkedin(props) {
  return (
    <SvgIcon viewBox="0 0 56 58" {...props}>
      <path d="M28 0C12.5358 0 0 12.9835 0 29C0 45.0165 12.5358 58 28 58C43.4642 58 56 45.0165 56 29C56 12.9835 43.4642 0 28 0ZM21.1458 41.0199H15.4758V22.1216H21.1458V41.0199ZM18.2758 19.8016C16.485 19.8016 15.3271 18.4875 15.3271 16.8623C15.3271 15.2039 16.52 13.9291 18.3487 13.9291C20.1775 13.9291 21.2975 15.2039 21.3325 16.8623C21.3325 18.4875 20.1775 19.8016 18.2758 19.8016ZM41.8542 41.0199H36.1842V30.5467C36.1842 28.1089 35.3617 26.4534 33.3112 26.4534C31.745 26.4534 30.8146 27.5742 30.4033 28.6526C30.2517 29.0363 30.2137 29.58 30.2137 30.1207V41.0169H24.5408V28.1481C24.5408 25.7889 24.4679 23.8162 24.3921 22.1185H29.3183L29.5779 24.7436H29.6917C30.4383 23.5111 32.2671 21.6926 35.3267 21.6926C39.0571 21.6926 41.8542 24.2815 41.8542 29.8458V41.0199Z" />
    </SvgIcon>
  );
}

export default Linkedin;
